<template>
    <div class="com-codics-hbb-order-admin-role-body">
        <div class="com-codics-hbb-order-admin-role-bar-content">
            <MyButton style="float: right;" @click.native="addDialogVisible = true;">&#xe632; 添加角色</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的用户数据吗？" @confirm="deleteRolesFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference" @click="addRoleFuc">
                    &#xe850;</MyButton>
            </el-popconfirm>
        </div>
        <div class="com-codics-hbb-order-admin-role-bar-content com-codics-hbb-order-admin-role-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="tableData" style="width: 100%;transition: .3s;" row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" show-expand-column default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column prop="id" label="ID" width="120" style="user-select: none;">
                </el-table-column>
                <el-table-column prop="role" label="名称" width="180">
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="180">
                </el-table-column>
                <el-table-column prop="state" label="状态" width="70"
                    :filters="[{ text: '正常', value: 0 }, { text: '禁选', value: 1 }]" :filter-method="stateFilter"
                    filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state == 0 ? '' : 'danger'" disable-transitions size="mini">{{
                scope.row.state == 0 ? '正常'
                    : '禁选' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" width="280">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.createtime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前角色数据吗？删除后所有子角色将一并删除！"
                            @confirm="deleteRolesFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                        <MyButton size="small" type="danger" style="float: right;margin-right:15px;" slot="reference"
                            @click.native="showBindDialog(scope.row);">权限
                        </MyButton>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <MyDialog v-model="addDialogVisible" title="添加角色">
            <el-input v-model="addForm.role" size="small" placeholder="请输入角色名称" clearable
                style="font-size: 12px;width:calc(50% - 7.5px) !important;margin-top:20px;" autocomplete="off"
                maxlength="15" show-word-limit></el-input>
            <el-cascader :options="tableData" placeholder="请选择上级角色"
                style="font-size: 12px !important;width:calc(50% - 7.5px) !important;margin-top:20px;margin-left:15px;"
                clearable size="small"
                :props="{ value: 'id', label: 'role', checkStrictly: true, children: 'children' }"
                @change="selectChange">
            </el-cascader>
            <el-select v-model="addForm.state" size="small"
                style="font-size: 12px !important;width:calc(50% - 7.5px) !important;margin-top:20px;"
                placeholder="请选择角色状态">
                <el-option v-for="item in [{ value: 0, label: '正常' }, { value: 1, label: '禁选' }]" :key="item.value"
                    :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input style="margin-top:20px;max-height:150px;margin-bottom:70px;font-size:12px !important;"
                resize="none" type="textarea" :rows="2" placeholder="请输入备注" v-model="addForm.remark">
            </el-input>
            <MyButton size="small" style="position:absolute !important;bottom:15px;right:15px;"
                @click.native="addRoleFuc">确认
            </MyButton>
        </MyDialog>
        <el-dialog :title="'权限管理' + ''" :visible.sync="bindMenuVisible" width="fit-content">
            <el-transfer v-model="transferValue" style="width:fit-content;margin-top:0px;margin-bottom:50px;"
                :data="transferData" :titles="['未分配权限', '已分配权限']" filterable target-order="push"
                :props="{ key: 'id', label: 'title', children: 'children' }"></el-transfer>
            <MyButton size="small" style="position:absolute;bottom:20px;right:20px;" @click.native="bindRamFuc">
                确认
            </MyButton>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { addRole, deleteRoles, updateRole, listRole, listMenus, bindRam } from '@/api';
export default {
    data() {
        return {
            nowId: null,
            pidData: '',
            formLabelWidth: '60px',
            addDialogVisible: false,
            bindMenuVisible: false,
            tableData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            transferData: [],
            transferValue: [],
            addForm: {
                role: '',
                pid: 0,
                state: 0,
                remark: ''
            }
        }
    },
    components: {
        MyButton,
        MyDialog
    },
    mounted() {

        this.listRoleFuc();

        this.listMenusFuc();

    },
    methods: {
        async bindRamFuc() {

            if (this.nowId == null) {

                this.$message({
                    showClose: true,
                    message: '请选择角色！',
                    type: 'warning'
                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await bindRam({ rid: this.nowId, mids: this.transferValue });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '绑定权限成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        showBindDialog(row) {

            this.nowId = row.id;

            this.bindMenuVisible = true;

            this.transferValue = row.ram == null ? [] : (row?.ram?.mid).split(',').map(Number);

        },
        async listMenusFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listMenus();

            loading.close();

            if (data.code == 200) {

                this.resolveList(data.data, this.transferData);

                this.hasChildren(this.transferData);

            } else {

                this.$message.error(data.message);

            }

        },
        hasChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.children != null) {

                    this.hasChildren(list[i].children);

                }

            }

        },
        resolveList(list, t) {
            for (let i in list) {
                if (list[i].child != null) {
                    this.resolveList(list[i].child, t);
                } else if (list[i].url != '') {
                    list[i].disabled = false;
                    t[t.length] = list[i];
                }
            }
        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.tableData = data.data;

                this.initChildren(this.tableData);

            } else {

                this.$message.error(data.message);

            }

        },
        async addRoleFuc() {

            if (this.addForm.role == '') {

                this.$message({
                    showClose: true,
                    message: '角色名称不能为空！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addRole(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '添加角色数据成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async deleteRolesFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteRoles({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        initChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.child != null) {

                    // list[i].hasChildren = true;

                    this.initChildren(list[i].child);

                } else {

                    // delete list[i].children;

                }

            }

        },
        selectChange(val) {

            this.addForm.pid = val.length == 0 ? 0 : val[val.length - 1];

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
.com-codics-hbb-order-admin-role-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-hbb-order-admin-role-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-role-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-role-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-role-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-ui-mydialog-xxbb-body-content .el-transfer__buttons {
    padding: 0 69px !important;
}
</style>